import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import styled from 'styled-components/macro';
import { Text, NumberValue } from '../../typography';
import { SIZE } from '../../types';
import { Currency } from '../../atoms/Input/Input.stories';

export const BasicTableContainer = styled.table`
  width: 100%;
`;

export const TableHeader = styled.td`
  padding: 0;
  text-align: ${(props) => props.align || 'left'};
`;

export const TableCell = styled.td`
  padding: 0;
  text-align: ${(props) => props.align || 'left'};
`;

type FormattedCellProps = {
  type?: string;
  currency?: string;
  item: Record<string, any>;
  accessor: string;
  size: SIZE;
};
function FormattedCell(props: FormattedCellProps) {
  const { type, item, accessor, size, currency } = props;

  if (type === "currency") {
    return <NumberValue value={get(item, accessor)} type={type} size={size} currency={currency} />;
  }

  if (type) {
    return <NumberValue value={get(item, accessor)} type={type} size={size} />;
  }

  return (
    <Text margin="none" size={size}>
      {get(item, accessor)}
    </Text>
  );
}

type BasicTableProps = {
  headers: Record<string, any>[];
  data: Record<string, any>[];
  headersSize?: SIZE;
  dataSize?: SIZE;
  cellStyle?: React.CSSProperties;
  style?: React.CSSProperties;
};
function BasicTable(props: BasicTableProps) {
  const {
    headers,
    data,
    cellStyle,
    style,
    headersSize = 'sm',
    dataSize = 'base',
  } = props;

  return (
    <BasicTableContainer style={style}>
      <tbody>
        <tr>
          {headers.map(({ title, align }) => (
            <TableHeader style={cellStyle} align={align} key={title}>
              <Text type="label" size={headersSize}>
                {title}
              </Text>
            </TableHeader>
          ))}
        </tr>
        {data.map((item, dataIndex) => (
          <React.Fragment key={dataIndex}>
            <tr>
              {headers.map(({ accessor, type, align, currency }, propIndex) => (
                <TableCell style={cellStyle} align={align} key={propIndex}>
                  <FormattedCell
                    type={type}
                    accessor={accessor}
                    item={item}
                    size={dataSize}
                    currency={currency}
                  />
                </TableCell>
              ))}
            </tr>
          </React.Fragment>
        ))}
      </tbody>
    </BasicTableContainer>
  );
}

BasicTable.propTypes = {
  data: PropTypes.array,
  headers: PropTypes.array,
  cellStyle: PropTypes.object,
  style: PropTypes.object,
};

FormattedCell.propTypes = {
  type: PropTypes.string,
  item: PropTypes.object,
  accessor: PropTypes.string,
};

export default BasicTable;
